class BackStorage {
  constructor() {
    this.backHistoryKey = '_backHistoryStateInitialPath';
    this.backHistoryState = '_backHistoryState';
  }

  setBackHistoryStorageInitialPath(path) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(this.backHistoryKey, path);
    }
  }

  getBackHistoryStorageInitialPath() {
    if (typeof window !== 'undefined') {
      return window.localStorage.getItem(this.backHistoryKey);
    }
  }

  setBackHistoryStorage() {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(this.backHistoryState, '0');
    }
  }

  getBackHistoryStorage() {
    if (typeof window !== 'undefined') {
      return window.localStorage.getItem(this.backHistoryState);
    }
  }

  removeBackHistoryStorage() {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(this.backHistoryState);
      window.localStorage.removeItem(this.backHistoryKey);
    }
  }
}

export const BackHistoryStorage = new BackStorage();
